export default __webpack_public_path__ + "static/media/heating.632ab09c.webp";